// extracted by mini-css-extract-plugin
export default {"barraDeProgressoContainer":"BarraDeProgresso_barraDeProgressoContainer__T9S+M","tempoEstimado":"BarraDeProgresso_tempoEstimado__wCJsY"};